import { useLocalSearchParams } from 'expo-router';
import StandalonePaperPageContent from './StandalonePaperPageContent';

export default function StandalonePaperRoute() {
    const { paperId, title } = useLocalSearchParams<{
        paperId: string;
        title?: string | string[];
    }>();

    if (!paperId) {
        return null;
    }

    const resolvedTitle = Array.isArray(title) ? title[0] : title;

    return (
        <StandalonePaperPageContent
            paperId={paperId}
            urlSlug={resolvedTitle || null}
        />
    );
}
